const contaCertaRoles = {
  ADMIN: {
    name: 'Administrador',
    value: 'ADMIN'
  }
};

const contaCertaRolesKeys = {};
Object.keys(contaCertaRoles).forEach(role => {
  contaCertaRolesKeys[role] = contaCertaRoles[role].value;
});
contaCertaRolesKeys.ALL = Object.keys(contaCertaRoles).map(key => contaCertaRoles[key].value);

module.exports = contaCertaRoles;
module.exports.contaCertaRolesKeys = contaCertaRolesKeys;
